<template src="./Control.html"></template>

<script>
import topMenu from "@/components/users/components/topMenu";
import Pagination from "@/components/components/pagination";
import Chart from '@/components/brand/dynamics/components/Chart';
import {createNamespacedHelpers} from "vuex";
import SelfDateRangePicker from "@/components/components/SelfDataRagePicker"

const {mapGetters, mapActions} = createNamespacedHelpers('users/control');

export default {
  name: "control",
  data() {
    return {
      showOverlay: false,
      showTypes: [
        {value: 'day', text: 'День'},
        {value: 'week', text: 'Неделя'},
        {value: 'month', text: 'Месяц'},
      ],
      currentUser: null,
      currentType: 'day',

      fieldsLabel: [
        {key: 'date', label: 'Время', sortable: true},
        {key: 'dictionary', label: 'Переводы', sortable: true},
        {key: 'import', label: 'Импорты', sortable: true},
        {key: 'product', label: 'Продукты', sortable: true},
        {key: 'category', label: 'Категории', sortable: true},
        {key: 'brand', label: 'Бренды', sortable: true},
        {key: 'ruQuery', label: 'Запросы (ru)', sortable: true},
        {key: 'wwQuery', label: 'Запросы (ww)', sortable: true},
      ],

      chartFrom: null,
      chartTo: null,
    }
  },
  components: {
    topMenu,
    Pagination,
    Chart,
    SelfDateRangePicker,
  },
  methods: {
    ...mapActions([
        'GET_USERS',
        'GET_DATA',
        'GET_CHART_DATA',
    ]),
    sortingChanged: function (ctx) {
      this.$store.commit('users/control/SORT_FIELD', ctx.sortBy)
      this.$store.commit('users/control/SORT_DIR', ctx.sortDesc ? 'desc' : 'asc')
      this.GET_DATA({th: this})
    },
    goToPage: function (page) {
      this.$store.commit('users/control/CURRENT_PAGE', page);
      this.GET_DATA({th: this});
    },
    perPage: function (page) {
      this.$store.commit('users/control/PER_PAGE', page);
      this.$store.commit('users/control/CURRENT_PAGE', 1);
      this.GET_DATA({th: this});
    },
    initPageSize: function() {
      let winHeight = window.innerHeight
      winHeight = Math.round((winHeight - 245) / 25)
      this.$store.commit('users/control/PER_PAGE', winHeight)
      this.$store.commit('users/control/CURRENT_PAGE', 1)
    },
    updateChart: function (val) {
      console.log(val)
      if (val === undefined)
        return

      this.chartFrom = val.from
      this.chartTo = val.to
      if (this.chartFrom != null && this.chartTo != null) {
        this.GET_CHART_DATA({th: this});
      }
    }
  },
  computed: {
    ...mapGetters([
      'USERS',
      'CURRENT_PAGE',
      'TOTAL_ROWS',
      'PER_PAGE',
      'CHART_DICTIONARY_DATA',
      'CHART_IMPORT_DATA',
      'CHART_PRODUCT_DATA',
      'CHART_BRAND_DATA',
      'CHART_CATEGORY_DATA',
      'CHART_RU_QUERY_DATA',
      'CHART_WW_QUERY_DATA',
      'TABLE_DATA',
    ]),

  },
  watch: {
    currentUser(newVal) {
      this.$store.commit('users/control/CURRENT_USER', newVal);
      this.GET_DATA({th: this});
      this.updateChart()
    },
    currentType(newVal) {
      this.$store.commit('users/control/SHOW_TYPE', newVal);
      this.GET_DATA({th: this});
      this.updateChart()
    }
  },
  mounted() {
    if (this.$store.getters.getAllowSection.indexOf('user') === -1) {
      this.$router.push({name: 'permissionDenied'});
      return;
    }
    this.initPageSize();
    this.GET_USERS({th: this});
  }
}
</script>

<style scoped>
.add-role {
  text-align: left;
}

.input-add-use {
  margin-top: 0.1em;
}

#roles i {
  display: inline-block;
  width: 100%;
  height: 38px;
  vertical-align: middle;
  line-height: 38px;
}

.hide {
  display: none;
}

.show {
  display: block;
}

#roles .t-cell {
  overflow: hidden;
}

.cell-cursor {
  cursor: cell;
}
.chart-box {
  width: 365px;
}
</style>